import React from "react";
import format from "date-fns/format";

type Props = {
  eventEndTimestamp: number;
};

export const EventDate = (props: Props) => {
  const formattedDate = React.useMemo(() => {
    return format(props.eventEndTimestamp, `MMM d, yyyy HH:mm O`);
  }, [props.eventEndTimestamp]);

  return <>{formattedDate}</>;
};
